import { Dispatch } from 'redux';
import { api } from "../config/api";
import { GetState } from "../config/store";
import { 
    getSchedulingRequest,
    getSchedulingSuccess,
    getSchedulingFailure,
    getInspectionRequest,
    getInspectionSuccess,
    getInspectionFailure,
    getSchedulingPublicationRequest,
    getSchedulingPublicationSuccess,
    getSchedulingPublicationFailure,
    clearInspection as clearInspectionReducer,
    clearPublication as clearPublicationReducer
} from '../reducers/scheduling';
import { axiosClient } from '../config/axios';
import { accumulateRequest, setAccumulateRequest } from '../reducers/requests';

export const getScheduling = (id: string ) => (dispatch: Dispatch) => _getScheduling(id, dispatch);
const _getScheduling = async ( id: string, dispatch: Dispatch ) => {
    try {
        dispatch({type: getSchedulingRequest});

        const response = await axiosClient.get(`${api.transactions}/${id}/delivery-schedules`);

        dispatch({type: getSchedulingSuccess, payload: response?.data.data.delivery_schedule});
    } catch (error: any) {
        const errorResponse = error?.response?.data?.error;
        console.log(errorResponse);
        dispatch({type: getSchedulingFailure});
    }
}


export const getSchedulingPublication = (id: string ) => (dispatch: Dispatch, getState: GetState) => _getSchedulingPublication(id, dispatch, getState);
const _getSchedulingPublication = async ( id: string, dispatch: Dispatch , getState: GetState) => {
    try {
        const {fetchingFirstTime} = getState().auth;

        if(fetchingFirstTime){
            dispatch({type: accumulateRequest, payload: {function: getSchedulingPublication, params: {id}, key: "getSchedulingPublication"} });
            return;
        }

        dispatch({type: getSchedulingPublicationRequest});

        const response = await axiosClient.get(`${api.transactions}/delivery-schedules/publication/${id}`);

        const cachedRequests = getState().requests.data;
        if(cachedRequests?.length){
            cachedRequests.find((cachedRequest) =>{
                if(cachedRequest?.key === "getSchedulingPublication"){
                    dispatch({type: setAccumulateRequest, payload: cachedRequests.filter((cached) => cached?.key !== "getSchedulingPublication") })
                }
            })
        };

        dispatch({type: getSchedulingPublicationSuccess, payload: response?.data?.data.schedules});
    } catch (error: any) {
        const errorResponse = error?.response?.data?.error;
        console.log(errorResponse);
        dispatch({type: getSchedulingPublicationFailure});
    }
}


export const getInspectionSchedule = (id: string) => (dispatch: Dispatch) => _getInspectionSchedules(id, dispatch);
const _getInspectionSchedules = async (id: string, dispatch: Dispatch) => {
    try {
       dispatch({type: getInspectionRequest});

       const response = await axiosClient.get(`${api.transactions}/${id}/inspection-schedules`);
       
       dispatch({type: getInspectionSuccess, payload: response?.data.data});
    } catch (error: any) {
        const errorResponse = error?.response?.data?.error;
        console.log(errorResponse);
        dispatch({type: getInspectionFailure})
    }
}

export const clearPublicationSchedule = () => (dispatch: Dispatch) => _clearPublicationSchedule(dispatch)
const _clearPublicationSchedule = (dispatch: Dispatch) => dispatch({ type: clearPublicationReducer})

export const clearInspectionSchedule = () => (dispatch: Dispatch) => _clearInspectionSchedule(dispatch)
const _clearInspectionSchedule = (dispatch: Dispatch) => dispatch({ type: clearInspectionReducer});